var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"grey lighten-3",style:({ borderRadius: '4px' }),attrs:{"flat":""}},[_c('v-card-text',{staticClass:"fill-height"},[_c('v-row',{staticClass:"fill-height",attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('span',[_vm._t("default")],2)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }